/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
let finBase = window._env_.VUE_APP_FIN_CENTER_HOST
let orderAuditBase = window._env_.VUE_APP_ORDER_AUDIT_API_HOST
export const getCustomerTable = params => {
  return axios.post(`${base}/query_customer`, params)
}
export const getCustomerDetail = params => {
  return axios.get(`${base}/customer_${params.id}`)
}
export const getBasicCustomerTable = params => {
  return axios.post(`${base}/basic-info/query_customer`, params)
}
export const getBasicCustomerDetail = params => {
  return axios.get(`${base}/basic-info/customer_${params.id}`)
}
export const getCustomerBalanceDetail = params => {
  return axios.get(`${base}/customer_balance_${params.id}`)
}
export const deleteCustomerData = params => {
  return axios.post(`${base}/delete_customer_${params.id}`)
}
export const updateCustomerData = params => {
  return axios.post(`${base}/edit_customer_${params.id}`, params)
}
export const getCustomerBalanceFlowTable = params => {
  return axios.post(`${base}/customer_balance_flow`, params)
}

export const getCustomerRelationshipDetail = params => {
  return axios.get(`${base}/get_customer_relationship_${params.id}`)
}

export const updateCustomerRelationshipData = params => {
  return axios.post(`${base}/edit_customer_relationship_${params.id}`, params)
}

// 项目审单统计（管理端统计页等直连 core）
export const getStatisticProjectAudit = params => {
  return axios.post(`${base}/statistic_project_audit`, params)
}

export const getCustomerOrderReviewTableApi = params => {
  return axios.post(`${orderAuditBase}/admin/statistic_customer_audit`, params)
}

// 项目审单管理列表（经由 order-audit-api 转发 core）
export const getProjectOrderReviewTable = params => {
  return axios.post(`${orderAuditBase}/admin/statistic_project_audit`, params)
}

// 项目审单管理列表（经由 order-audit-api 转发 core）
export const getBatchOrderReviewTable = params => {
  return axios.post(`${orderAuditBase}/admin/statistic_batch_audit`, params)
}


/** ======= 财务系统 - 开票信息(抬头) ======== **/

// 获取客户开票信息(抬头)
export const getCustomerReceiptInfo = params => {
  return axios.post(`${finBase}/receipt-applications/receipt_info/customer/${params.customerid}/lists`)
}

export const getReceiptInfo = params => {
  return axios.get(`${finBase}/receipt-applications/receipt_info/${params.id}`)
}

export const getCustomerReceiptOptions = params => {
  return axios.post(`${finBase}/receipt-applications/receipt_info/customer/${params.customerid}/lists`)
}

export const disableCustomerReceiptInfo = params => {
  return axios.post(`${finBase}/receipt-applications/receipt_info/${params.id}/disable`, params)
}

export const enableCustomerReceiptInfo = params => {
  return axios.post(`${finBase}/receipt-applications/receipt_info/${params.id}/enable`, params)
}

export const getReceiptInfoCollectList = params => {
  return axios.post(`${finBase}/receipt-applications/receipt_info/${params.id}/collect_list`, params)
}

// 批量更新开票信息
export const batchCreateCustomerReceiptInfo = params => {
  return axios.post(`${base}/receipt-apply/batch_edit_receipt_info`, params)
}



// WEBPACK FOOTER //
// ./src/views/customer/customer.api.js